export function checkPermisos(menuLink, permisos, user, history) {
  let canDo = {
    canAdd: false,
    canView: false,
    canModify: false,
    canDelete: false,
    canList: false,
    canExport: false,
    special1: false,
    special2: false,
    special3: false,
    special4: false,
    special5: false,
    special6: false,
    special7: false,
    special8: false,
    special9: false,
    special10: false,
  };
  if (permisos || user.profile.isAdmin || user.profile.isSuperAdmin) {
    var found =
      user.profile.isAdmin || user.profile.isSuperAdmin
        ? false
        : permisos.find((element) => element.menu.link === menuLink);

    if (!found && !user.profile.isAdmin && !user.isSuperAdmin) {
      // if (!found && user.isSuperAdmin) {
      history.push("/notallowed");
    } else {
      canDo = {
        canAdd: user.profile.isAdmin || user.isSuperAdmin ? true : found.canAdd,
        canView: user.profile.isAdmin || user.isSuperAdmin ? true : found.canView,
        canModify: user.profile.isAdmin || user.isSuperAdmin ? true : found.canModify,
        canDelete: user.profile.isAdmin || user.isSuperAdmin ? true : found.canDelete,
        canList: user.profile.isAdmin || user.isSuperAdmin ? true : found.canList,
        canExport: user.profile.isAdmin || user.isSuperAdmin ? true : found.canExport,
        special1: user.profile.isAdmin || user.isSuperAdmin ? true : found.special1,
        special2: user.profile.isAdmin || user.isSuperAdmin ? true : found.special2,
        special3: user.profile.isAdmin || user.isSuperAdmin ? true : found.special3,
        special4: user.profile.isAdmin || user.isSuperAdmin ? true : found.special4,
        special5: user.profile.isAdmin || user.isSuperAdmin ? true : found.special5,
        special6: user.profile.isAdmin || user.isSuperAdmin ? true : found.special6,
        special7: user.profile.isAdmin || user.isSuperAdmin ? true : found.special7,
        special8: user.profile.isAdmin || user.isSuperAdmin ? true : found.special8,
        special9: user.profile.isAdmin || user.isSuperAdmin ? true : found.special9,
        special10: user.profile.isAdmin || user.isSuperAdmin ? true : found.special10,
      };
    }
  }
  return canDo;
}
